import { render, staticRenderFns } from "./OrdersAddendumForm.vue?vue&type=template&id=4649a12c&"
import script from "./OrdersAddendumForm.vue?vue&type=script&lang=js&"
export * from "./OrdersAddendumForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports